/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AuthRoutingModule } from './auth-routing.module';
import { NbAuthModule } from '@nebular/auth';
import { MatIconModule } from '@angular/material/icon'; 
import { NbCardModule, NbAlertModule, NbButtonModule, NbCheckboxModule, NbInputModule, NbIconModule } from '@nebular/theme';

import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { TranslateModule } from '@ngx-translate/core';
import { SigninComponent } from './signin/signin.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NbCardModule,
    NbAlertModule,
    NbInputModule,
    NbButtonModule,
    MatIconModule,
    NbIconModule,
    NbCheckboxModule,
    AuthRoutingModule,
    TranslateModule,
    NbAuthModule,
  ],
  declarations: [
    LoginComponent,
    LogoutComponent,
    SigninComponent
  ],
})
export class AuthModule {
}